import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";

const API = "https://api.hmsaa.com.mx:5001/api";

export default function ModalDepartamento({ open, onClose, editing, refresh }) {
  const [form, setForm] = useState({
    nombre: "",
    abreviatura: ""
  });

  useEffect(() => {
    if (!open) return;

    if (editing) {
      axios.get(`${API}/departamentos/${editing}`)
        .then(res => {
          setForm({
            nombre: res.data.nombre,
            abreviatura: res.data.abreviatura
          });
        })
        .catch(() => {
          Swal.fire("Error", "No se pudo cargar el departamento", "error");
        });
    } else {
      setForm({ nombre: "", abreviatura: "" });
    }
  }, [open, editing]);

  const guardar = async () => {
    try {
      if (!form.nombre || !form.abreviatura) {
        Swal.fire("Faltan datos", "Todos los campos son obligatorios", "warning");
        return;
      }

      if (editing) {
        await axios.put(`${API}/departamentos/${editing}`, form);
      } else {
        await axios.post(`${API}/departamentos`, form);
      }

      await refresh();

      Swal.fire({
        icon: "success",
        title: editing ? "Departamento actualizado" : "Departamento creado",
        timer: 1200,
        showConfirmButton: false
      });

      onClose();
    } catch (e) {
      const msg = e.response?.data?.error || "Error inesperado";
      Swal.fire("Error", msg, "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {editing ? "Editar Departamento" : "Nuevo Departamento"}
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="Nombre"
          sx={{ mb: 2 }}
          value={form.nombre}
          onChange={e => setForm({ ...form, nombre: e.target.value })}
        />
        <TextField
          fullWidth
          label="Abreviatura"
          value={form.abreviatura}
          onChange={e =>
            setForm({ ...form, abreviatura: e.target.value.toUpperCase() })
          }
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={guardar}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
